export interface IDriver {
  first_name: string;
  email: string;
}
export class Driver implements IDriver {
  email = '';
  first_name = '';
  client_id = 0;
  last_name = '';
  phone = '';
  constructor() {}
}
export interface IDriverFetch extends IDriver {
  readonly id: number;
  client_id: number;
  driver_license_id: number;
  order: [];
  created_at: Date;
  updated_at: Date;
}
